import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import classnames from 'classnames';
const UnsavedChangesNotification = _ref => {
  let noAction = _ref.noAction,
    yesAction = _ref.yesAction,
    close = _ref.close;
  return /*#__PURE__*/React.createElement("div", {
    className: "t-notification-unsaved-changes"
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames('tqc-notification-info-header', 't-notification-header')
  }, "You have unsaved changes."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "Would you like to save them before continuing?", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: () => {
      yesAction();
      close();
    },
    className: classnames('t-notification-button-left', 't-nbl-label-yes')
  }, "Yes"), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    style: {
      marginLeft: '10px'
    },
    onClick: () => {
      noAction();
      close();
    },
    className: classnames('t-notification-button-middle', 't-nbm-label-no')
  }, "No"), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    style: {
      float: 'right'
    },
    onClick: () => close(),
    className: classnames('t-notification-button-right', 't-nbr-label-cancel')
  }, "Cancel"));
};
UnsavedChangesNotification.propTypes = {
  noAction: PropTypes.func.isRequired,
  yesAction: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired
};
export default UnsavedChangesNotification;